import { render, staticRenderFns } from "./DevGenerateStats.vue?vue&type=template&id=bc20eac6&"
import script from "./DevGenerateStats.vue?vue&type=script&lang=js&"
export * from "./DevGenerateStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports